module.exports = __webpack_public_path__ + "img/11.b0d85036.gif";